import SolutionAssetHierarchy from './SolutionAssetHierarchy';

export default SolutionAssetHierarchy;
